import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Snackbar, SnackbarContent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { guardRoute, InitSessionObserver, showSnack } from "../utils/utils";
import DashboardNavbar from "./component/@navs/navbar";
import DashboardSidebar from "./component/@navs/sidebar";
import { coreStyles } from "../theme/style";
import { AMQPWebSocketClient } from "../routing/pubsub/amqp-websocket-client.mjs";
import { setQueue } from "../utils/@redux/queue";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default function Dashboard() {
  InitSessionObserver();
  let queueDispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { snackbar: { snack }, queue: { queue } } = useSelector((state) => state);
  const appStyle = coreStyles();
  const pathName = window.location.pathname;

  useEffect(() => {
    if (!queue) {
      const {
        REACT_APP_LAVIN_MQ_URL: url,
        REACT_APP_LAVIN_MQ_USERNAME: username,
        REACT_APP_LAVIN_MQ_PASSWORD: password,
        REACT_APP_LAVIN_MQ_VHOST: vhost } = process.env;
      const amqp = new AMQPWebSocketClient(url, vhost, username, password)
      amqp.connect().then(async conn => {
        const channel = await conn.channel();
        const _queue = await channel.queue("EVENT_TRIGGER", { durable: true });
        console.log(`LavinMQ connection established successfully`);
        queueDispatch(setQueue(_queue));
      })
    }
    // eslint-disable-next-line
  }, [queue]);

  useEffect(() => {
    guardRoute();
    return () => {};
    // eslint-disable-next-line
  }, [pathName]);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />

      <MainStyle>
        {snack && snack.message && (
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            onClose={() => {
              showSnack(null);
            }}
            open={snack.message && snack.message.length > 0}
            autoHideDuration={5000}
            message={snack.message}
          >
            <SnackbarContent
              className={appStyle.snackbar}
              message={<span id="client-snackbar">{snack.message}</span>}
            />
          </Snackbar>
        )}
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
